export default __webpack_public_path__ + "static/media/BrokenTeapot.6b5c763b.pdf";